import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {
      this.canvasForm = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(5.5, 0.5)`)
      .attr('font-family', 'roboto').attr('cursor', 'default')


      this.draw_Header()
      this.draw_Contents()
      this.draw_Scrollbar()




      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },


  }
}